import { useMemo } from 'react';

export function usePortalSubdomain() {
  return useMemo(() => {
    // Method 1: Check URL query parameter
    const urlParams = new URLSearchParams(window.location.search);
    const portalParam = urlParams.get('portal');
    if (portalParam) {
      return portalParam;
    }

    // Method 2: Check subdomain from hostname
    const hostname = window.location.hostname;
    const parts = hostname.split('.');

    // For localhost development, check if we have subdomain.localhost pattern
    if (hostname.includes('localhost') && parts.length >= 2 && parts[0] !== 'localhost') {
      return parts[0];
    }

    // For real domains, need at least 3 parts (subdomain.domain.tld) and not www
    // e.g., portal.legishq.com = 'portal', legishq.com = null, www.legishq.com = null
    if (parts.length >= 3 && parts[0] !== 'www' && !hostname.includes('azurewebsites')) {
      return parts[0];
    }

    return null;
  }, []);
}

export function isPortalSubdomain(): boolean {
  // Method 1: Check URL query parameter
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('portal')) {
    return true;
  }

  // Method 2: Check subdomain from hostname
  const hostname = window.location.hostname;
  const parts = hostname.split('.');

  // For localhost development, check if we have subdomain.localhost pattern
  if (hostname.includes('localhost') && parts.length >= 2 && parts[0] !== 'localhost') {
    return true;
  }

  // For real domains, need at least 3 parts (subdomain.domain.tld) and not www
  // e.g., portal.legishq.com = true, legishq.com = false, www.legishq.com = false
  return parts.length >= 3 && parts[0] !== 'www' && !hostname.includes('azurewebsites');
}
